export function groupBy<T>(arr: T[], fn: (item: T) => string) {
  return arr.reduce<Record<string, T[]>>((prev, curr) => {
    const groupKey = fn(curr);
    const group = prev[groupKey] || [];
    group.push(curr);
    return { ...prev, [groupKey]: group };
  }, {});
}

export function groupByToUniqueAndMutateValue<T, V>(arr: T[], fn: (item: T) => string, valueMutator: (item: T) => V) {
  return arr.reduce<Record<string, V>>((prev, curr) => {
    const groupKey = fn(curr);
    return { ...prev, [groupKey]: valueMutator(curr) };
  }, {});
}
